"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var RoundCheck2_exports = {};
__export(RoundCheck2_exports, {
  default: () => RoundCheck2_default
});
module.exports = __toCommonJS(RoundCheck2_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.3438 1.79297C11.4896 1.79297 12.5703 2.00781 13.5859 2.4375C14.5885 2.88021 15.4674 3.47917 16.2227 4.23438C16.9779 4.97656 17.5703 5.85547 18 6.87109C18.4427 7.8737 18.6641 8.94792 18.6641 10.0938C18.6641 11.2396 18.4427 12.3203 18 13.3359C17.5703 14.3385 16.9779 15.2174 16.2227 15.9727C15.4674 16.7279 14.5885 17.3203 13.5859 17.75C12.5703 18.1927 11.4896 18.4141 10.3438 18.4141C9.19792 18.4141 8.1237 18.1927 7.12109 17.75C6.10547 17.3203 5.22005 16.7279 4.46484 15.9727C3.72266 15.2174 3.13021 14.3385 2.6875 13.3359C2.25781 12.3203 2.04297 11.2396 2.04297 10.0938C2.04297 8.94792 2.25781 7.8737 2.6875 6.87109C3.13021 5.85547 3.72266 4.97656 4.46484 4.23438C5.22005 3.47917 6.10547 2.88021 7.12109 2.4375C8.1237 2.00781 9.19792 1.79297 10.3438 1.79297ZM10.3438 3.25781C9.40625 3.25781 8.52083 3.43359 7.6875 3.78516C6.85417 4.14974 6.125 4.64453 5.5 5.26953C4.88802 5.88151 4.39974 6.60417 4.03516 7.4375C3.68359 8.27083 3.50781 9.15625 3.50781 10.0938C3.50781 11.0443 3.68359 11.9362 4.03516 12.7695C4.39974 13.5898 4.88802 14.3125 5.5 14.9375C6.125 15.5625 6.85417 16.0508 7.6875 16.4023C8.52083 16.7669 9.40625 16.9492 10.3438 16.9492C11.2943 16.9492 12.1862 16.7669 13.0195 16.4023C13.8398 16.0508 14.5625 15.5625 15.1875 14.9375C15.8125 14.3125 16.3008 13.5898 16.6523 12.7695C17.0169 11.9362 17.1992 11.0443 17.1992 10.0938C17.1992 9.15625 17.0169 8.27083 16.6523 7.4375C16.3008 6.60417 15.8125 5.88151 15.1875 5.26953C14.5625 4.64453 13.8398 4.14974 13.0195 3.78516C12.1862 3.43359 11.2943 3.25781 10.3438 3.25781ZM13.293 7.45703C13.3971 7.45703 13.4883 7.47656 13.5664 7.51562C13.6576 7.54167 13.7357 7.58724 13.8008 7.65234C13.8659 7.71745 13.918 7.78906 13.957 7.86719C13.9961 7.94531 14.0156 8.03646 14.0156 8.14062C14.0156 8.19271 14.0091 8.2513 13.9961 8.31641C13.9831 8.36849 13.957 8.42057 13.918 8.47266L13.8594 8.55078L13.8008 8.62891L9.67969 12.5547C9.60156 12.6198 9.51693 12.6719 9.42578 12.7109C9.34766 12.737 9.26302 12.75 9.17188 12.75C9.10677 12.75 9.04167 12.7435 8.97656 12.7305C8.92448 12.7174 8.8724 12.6914 8.82031 12.6523L8.74219 12.6133L8.66406 12.5352L6.90625 10.8555C6.82812 10.7904 6.76953 10.7188 6.73047 10.6406C6.70443 10.5625 6.69141 10.4714 6.69141 10.3672C6.69141 10.276 6.70443 10.1914 6.73047 10.1133C6.76953 10.0352 6.82812 9.96354 6.90625 9.89844C6.97135 9.82031 7.04297 9.76823 7.12109 9.74219C7.21224 9.70312 7.30339 9.68359 7.39453 9.68359C7.45964 9.68359 7.51823 9.6901 7.57031 9.70312C7.63542 9.71615 7.69401 9.74219 7.74609 9.78125L7.82422 9.82031L7.90234 9.89844L9.17188 11.0898L12.7852 7.65234C12.8372 7.61328 12.8893 7.58073 12.9414 7.55469C12.9935 7.51562 13.0456 7.48958 13.0977 7.47656L13.1953 7.45703H13.293Z",
      fill: "currentColor"
    }
  )
);
const SvgRoundCheck2 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var RoundCheck2_default = SvgRoundCheck2;
